module.exports = __webpack_public_path__ + "img/posteg.9b4a3dd8.jpeg";